import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Courses", path: "/courses" },
  { label: "About", path: "/about" },
  { label: "Reviews", path: "/reviews" },
  { label: "Group Training", path: "/group-training" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  const handleBookNow = (e) => {
    if (location.pathname === '/booking') {
      e.preventDefault();
      const el = document.getElementById('reserve-spot');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white shadow-sm border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-6 lg:px-12 h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer whitespace-nowrap">
          <img
            src="https://public.readdy.ai/ai/img_res/0bc8c1a5-8349-4da7-bc3f-8127b6f3ae55.png"
            alt="Cardiocraft CPR Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-200 rounded-md cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? "text-brand-purple"
                    : scrolled || !isHome
                    ? "text-brand-black hover:text-brand-purple"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/booking#reserve-spot"
            onClick={handleBookNow}
            className="bg-brand-gold text-brand-black font-semibold text-sm px-6 py-2.5 rounded-md hover:bg-brand-gold-dark transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Book Now
          </Link>
        </div>

        {/* Mobile menu toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-md transition-colors ${
            scrolled || !isHome ? "text-brand-black" : "text-white"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg px-6 py-4">
          <ul className="flex flex-col gap-1 mb-4">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`block px-4 py-3 text-sm font-medium rounded-md transition-colors cursor-pointer ${
                    location.pathname === link.path
                      ? "text-brand-purple bg-brand-purple-pale"
                      : "text-brand-black hover:text-brand-purple hover:bg-brand-purple-pale"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/booking#reserve-spot"
            onClick={handleBookNow}
            className="block text-center bg-brand-gold text-brand-black font-semibold text-sm px-6 py-3 rounded-md hover:bg-brand-gold-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            Book Now
          </Link>
        </div>
      )}
    </header>
  );
}
